const IOS = 'ios';
const ANDROID = 'android';
const FLUTTER = 'flutter';
const UNKNOWN = 'unknown';

const mobileOS = () => {
  if (window.flutter_inappwebview) {
    return FLUTTER;
  }
  if (window.AndroidInterface) {
    return ANDROID;
  }
  if (window.webkit && window.webkit.messageHandlers) {
    return IOS;
  }
  return UNKNOWN;
};

const triggerFlutterHandler = (name) => window.flutter_inappwebview?.callHandler(name);

export const isInsideMobileApp = () => mobileOS() !== UNKNOWN;

export const continueToApp = () => {
  const nativeType = mobileOS();

  if (nativeType === IOS && window.webkit.messageHandlers.continueToApp) {
    if (typeof window.webkit.messageHandlers.continueToApp === 'object') {
      window.webkit.messageHandlers.continueToApp.postMessage(null);
    }
    if (typeof window.webkit.messageHandlers.continueToApp === 'function') {
      window.webkit.messageHandlers.continueToApp();
    }
  }
  if (nativeType === ANDROID && window.AndroidInterface) {
    const androidInterface = window.AndroidInterface;
    androidInterface.continueToApp();
  }
  if (nativeType === FLUTTER) {
    triggerFlutterHandler('continueToApp');
  }
};
